import { fetchWrapper } from "../Helpers/fetch-wrapper";
import { roleNamesFromLegacyIds } from "../Helpers/roles";
import { toApiPage } from "./queryParams";

const getAllPersons = async (page, pageSize, sortBy, sortOrder, filters) => {
  let params = [];
  if (page || page === 0) params.push("page=" + toApiPage(page));
  if (pageSize) params.push("pageSize=" + pageSize);
  if (sortBy) params.push("sortBy=" + sortBy);
  if (sortOrder) params.push("sortOrder=" + sortOrder);
  if (filters) {
    Object.entries(filters).forEach(([key, value]) => {
      if (Array.isArray(value) && value.length > 0) {
        let param = "";
        param += `filters[${key}]=[`;
        let values = value.map((ele) => ele.id);
        values.join(",");
        param += values;
        param += `]`;
        params.push(param);
      } else if (typeof value == "string" && value) {
        params.push(`filters[${key}]=${value}`);
      }
    });
  }
  const response = await fetchWrapper.get(
    `${process.env.REACT_APP_API_ENDPOINT}/user${
      params !== "" ? "?" + params.join("&") : ""
    }`
  );

  return response;
};

const getPersonById = async (id) => {
  const response = fetchWrapper.get(
    `${process.env.REACT_APP_API_ENDPOINT}/user/${id}`
  );

  return response;
};

const createPerson = async (params) => {
  const response = fetchWrapper.post(
    `${process.env.REACT_APP_API_ENDPOINT}/user`,
    {
      name: params.name || undefined,
      email: params.email || undefined,
      contact_email: params.contact_email || undefined,
      home_address: params.homeAddress || undefined,
      post_code: params.postCode || undefined,
      office: params.office || undefined,
      // holiday_allowance: params.holidayAllowance || undefined,
      // holiday_taken: params.holidayTaken || undefined,
      line_manager_id: params.lineManagerId || undefined,
      roles: params.roles || undefined,
      phone_no: params.phone_no || undefined,
      enabled: params.enabled || undefined,
      organisation_id: params?.organisation?.id || undefined,
      password: params?.password || undefined,
      password_confirmation: params?.password_confirmation || undefined,
    }
  );

  return response;
};

const updatePerson = async (id, params) => {
  const response = fetchWrapper.put(
    `${process.env.REACT_APP_API_ENDPOINT}/user/${id}`,
    {
      name: params.name || undefined,
      email: params.email || undefined,
      roles: params.roles || undefined,
      phone_no: params.phone_no || undefined,
      enabled: params.enabled || undefined,
    }
  );

  return response;
};

const deletePerson = async (id) => {
  const response = fetchWrapper.delete(
    `${process.env.REACT_APP_API_ENDPOINT}/user/${id}`
  );
  return response;
};

const getRFITallies = async (date, filters) => {
  let params = "";
  if (filters) {
    Object.entries(filters).forEach(([key, value]) => {
      params += `&filters[${key}]=[`;
      if (Array.isArray(value)) {
        let values = value.map((ele) => ele.id);
        values.join(",");
        params += values;
      }
      params += `]`;
    });
  }
  const response = fetchWrapper.get(
    `${process.env.REACT_APP_API_ENDPOINT}/user/rfitallies?date=${date}&${
      params !== "" ? params : ""
    }`
  );
  return response;
};

const acceptedTerms = async (user) => {
  const response = fetchWrapper.put(
    `${process.env.REACT_APP_API_ENDPOINT}/user/acceptedterms`
  );
  return response;
};

const bulkUpload = async (file) => {
  let data = new FormData();
  data.append("file", file);

  const response = fetchWrapper.post(
    `${process.env.REACT_APP_API_ENDPOINT}/user/bulkupload`,
    data,
    true
  );
  return response;
};

const setOrganisation = async (org_id) => {
  const response = fetchWrapper.put(
    `${process.env.REACT_APP_API_ENDPOINT}/user/setorganisation`,
    {
      organisation_id: org_id,
    }
  );
  return response;
};

const getRosteringmanagers = async () => {
  const response = fetchWrapper.get(
    `${process.env.REACT_APP_API_ENDPOINT}/user/rosteringmanagers`
  );
  return response;
};

const getJobRoles = async () => {
  const response = fetchWrapper.get(
    `${process.env.REACT_APP_API_ENDPOINT}/jobrole/`
  );
  return response;
}

const setJobRoles = async (id, job_role_ids) => {
  const response = fetchWrapper.put(
    `${process.env.REACT_APP_API_ENDPOINT}/user/${id}/setjobroles`,
    {
      job_role_ids: job_role_ids,
    }
  );
  return response;
}

const getCurrent = async () => {
  return fetchWrapper.get(
    `${process.env.REACT_APP_API_ENDPOINT}/user/current`)
}

const getUsersByType = (types) => {
  let filters = `filters[role_id]=[${types.join(',')}]`;
  return fetchWrapper.get(
    `${process.env.REACT_APP_API_ENDPOINT}/user?${filters}`
  );
}

const getOrganisations = () => {
  const response = fetchWrapper.get(
    `${process.env.REACT_APP_API_ENDPOINT}/organisation`
  );

  return response;
}

export const PersonsService = {
  getAllPersons,
  createPerson,
  getPersonById,
  updatePerson,
  deletePerson,
  getRFITallies,
  acceptedTerms,
  bulkUpload,
  setOrganisation,
  getRosteringmanagers,
  getJobRoles,
  setJobRoles,
  getCurrent,
  getUsersByType,
  getOrganisations,
};

